// Auth
export const LOGIN_API_PATH = "login";
export const RESET_PASSWORD = "password/forgot";
export const UPDATE_PASSWORD = "password/reset";

export const REGISTER_API_PATH = "signup";

// Breeds
export const GET_ALL_BREEDS_API_PATH = "breeds/{speciesId}";

// Genders
export const GET_ALL_GENDERS_API_PATH = "genders";

// Species
export const GET_ALL_SPECIES_API_PATH = "species";

// Clients
export const CLIENT_PATH = "client";
export const ADD_CLIENT_API_PATH = `${CLIENT_PATH}/create`;
export const GET_ALL_CLIENTS_API_PATH = `${CLIENT_PATH}/search?search={search}`;

// Pets
export const PET_PATH = "patient";
export const ADD_PET_API_PATH = `${PET_PATH}/create`;
export const FIND_PETS_API_PATH = `${PET_PATH}/find`;

// Appointments
export const GET_ALL_APPOINTMENTS_PATH = (id?: string) =>
  `appointment${id ? `?provider=${id}` : ""}`;
export const GET_ALL_NOTIFY_APPOINTMENTS_PATH = (id?: string) =>
  `appointment/current${id ? `?provider=${id}` : ""}`;
export const GET_ALL_APPOINTMENTS_TYPES_PATH = `${"appointment"}/types`;
export const GET_ALL_APPOINTMENTS_PROVIDERS_PATH = `${"appointment"}/providers`;
export const GET_MORE_APPOINTMENTS_SLOTS_PATH = `${"appointment"}/more`;
export const SUBMIT_TIME_SLOTS_REQUEST_PATH = `${"appointment"}/submit`;
export const CREATE_APPOINTMENT_PATH = `${"appointment"}/create`;

// Invite
export const INVITE_PATH = "invite";

// Users Apis path
export const SEND_OTP_FOR_EMAIL_PATH = "user/send-verification-code";
export const SEND_OTP_FOR_NUMBER_PATH = "user/send-verification-phone-code";
export const VERIFY_EMAIL_OTP_PATH = "user/verify-email-code";
export const VERIFY_NUMBER_OTP_PATH = "user/verify-phone-code";
export const CREATE_CLIENT_PATH = "user/client/create";
export const UPDATE_CLIENT_PATH = "user/client/update";
export const UPDATE_CLIENT = "client/update";
export const CREATE_PET_PATH = "user/patient/create";
export const GET_ALL_USERS_BY_EMAIL = (email: string) =>
  `user/client/search?search=${email}`;
export const GET_ALL_USERS_BY_NUMBER = (number: string) =>
  `user/client/search?search=${number}`;
export const GET_ALL_USER_SPECIES_API_PATH = "user/species";
export const GET_ALL_USER_BREEDS_API_PATH = "user/breeds/{speciesId}";
export const GET_ALL_USER_GENDERS_API_PATH = "user/genders";
export const FIND_USER_PETS_API_PATH = `user/${PET_PATH}/find`;
export const GET_ALL_USER_APPOINTMENTS_TYPES_PATH = `user/appointment/types`;
export const GET_ALL_USER_APPOINTMENTS_PATH = "user/appointment";
export const SUBMIT_USER_TIME_SLOTS_REQUEST_PATH = `user/appointment/submit`;
export const GET_MORE_USER_APPOINTMENTS_SLOTS_PATH = `user/appointment/more`;
export const CREATE_USER_APPOINTMENT_PATH = `user/appointment/create`;
export const LOGUT_USER_PATH = `user/logout`;

// Admin routes
export const ADMIN_INVITE_PATH = "admin/send-invite-link";
export const GET_ALL_USERS_PATH = "admin/user/get-all";
export const UPDATE_ADMIN_PASSWORD_PATH = "/update-password";
export const CREATE_BLOCK_OFF_PATH = "admin/blockoff/create";
export const GET_ALL_BLOCKOFF_PATH = "admin/blockoff/get-all";
export const DELETE_SINGLE_BLOCKOFF_PATH = "admin/blockoff/remove";
export const DELETE_ALL_BLOCKOFF_PATH = "admin/blockoff/delete-all";
export const REPEAT_INTERVAL_PATH = "admin/blockoff/get-valid-repeat-interval";
export const CHANGE_USER_ACCESS_PATH = "admin/user/update-status";
export const GET_ALL_TIME_ADJUSTMENTS_PATH =
  "admin/time-adjustments/get?key=routing_time";
export const GET_ALL_RESERVE_DATA_PATH =
  "admin/time-adjustments/get?key=reserve_data";
export const CREATE_TIME_ADJUSTMENT_PATH = "admin/time-adjustments/create";
export const UPDATE_TIME_ADJUSTMENT_PATH = "admin/time-adjustments/update";
export const GET_ALL_TRAVEL_CLIENTS_PATH = "admin/clients/with-travel-clients";
export const ATTACH_TRAVEL_CLIENT_PATH = "admin/clients/attach-travel-client";
export const GET_RULESET_PATH = "admin/ruleset/get";
export const UPDATE_RULESET_PATH = "admin/ruleset/update";

// Provider Schedules
export const GET_PROVIDER_SCHEDULE_PATH = (providerId: string) => `admin/provider-schedules/${providerId}`;
export const UPDATE_PROVIDER_SCHEDULE_PATH = (providerId: string) => `admin/provider-schedules/${providerId}`;

// Reschedule Schedule
export const GET_RESCHEDULE_SCHEDULES_PATH = "admin/reschedule-schedule/get";
export const CREATE_RESCHEDULE_SCHEDULE_PATH = "admin/reschedule-schedule/create";
export const UPDATE_RESCHEDULE_SCHEDULE_PATH = (id: number) => `admin/reschedule-schedule/update/${id}`;
export const DELETE_RESCHEDULE_SCHEDULE_PATH = (id: number) => `admin/reschedule-schedule/delete/${id}`;
export const RUN_RESCHEDULE_PATH = "admin/reschedule-schedule/run";
export const GET_RESCHEDULE_LATEST_RESULT_PATH = "admin/reschedule-schedule/latest-result";
export const SEND_NOTIFICATION_PATH = "client/send-notification";
export const FETCH_PROVIDERS_APPOINTMENTS = "admin/api/appointment/providers";
export const GET_RESCHEDULE_DATA = (token: string) => `/reschedule/${token}`;
export const CONFIRM_RESCHEDULE_DATA = (token: string) =>
  `/reschedule/${token}/confirm`;
export const CANCEL_RESCHEDULE_NOTIFY = (token: string) =>
  `/reschedule/${token}/cancel-notify`;
